import React from "react";
import { Box, Typography } from "@mui/material";

const ComingSoon = ({ title }) => (
  <Box sx={{ p: 3, background: "#f7f8fa", minHeight: "100vh" }}>
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#111827" }}>{title}</Typography>
    </Box>
    <Box
      sx={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        p: 6,
        textAlign: "center",
      }}
    >
      <Typography sx={{ color: "#6b7280", fontSize: 14 }}>Coming soon.</Typography>
    </Box>
  </Box>
);

export default ComingSoon;
